<template>
  <div class="page-content original-dialog">
    <div class="custom-detail">
      <div class="form-module-tit">{{ $locale("sidemenu.memberFilter.title") + $locale("cinemaWebsite.custom.create") }}
      </div>
      <el-form :model="form" :rules="formRules" ref="detailForm" :inline="true" class="memberFilterForm">
        <el-form-item :label="$locale('global.name')" prop="name" style="width: 100%;" label-width="60px">
          <el-row :gutter="20">
            <el-col :span="18">
              <el-input v-model="form.name" style="width: 847px;" />
            </el-col>
            <el-col :span="3">
              <el-select placeholder="選択してください" v-model="mailingId" clearable>
                <el-option
                  v-for="(item, idx) in mailingList"
                  :label="item.name"
                  :key="idx"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-button class="egl-btn-yellow" @click="copy_fn" style="width: 100%;" :disabled="!mailingId">コピー</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$locale('cinemaWebsite.custom.table.header.description')" prop="describe" style="width: 100%;" label-width="60px">
          <el-row>
            <el-col :span="18">
              <el-input v-model="form.describe" style="width: 847px;" />
            </el-col>
          </el-row>
        </el-form-item>
        <p style="font-size: 16px;font-weight: 400px;">条件指定</p>
        <el-form-item :label="$locale('membership.memberList.dialog.enrollmentDate')" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.timeCheck" @change="updatePersonCount" /></el-col>
            <openDateCom :propForm="form" type="start" @change="change_fn" />
            <el-col :span="1" style="text-align: center;">から</el-col>
            <openDateCom :propForm="form" type="end" @change="change_fn" />
            <el-col :span="1" style="text-align: center;">まで</el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$locale('couponList.distribution.ageGroup')" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.ageCheck" @change="updatePersonCount" /></el-col>
            <el-col :span="4"><el-select v-model="form.age" clearable multiple @change="selectAge_fn">
              <el-option v-for="(item, idx) in Object.entries(ageGroup).map(([key, value]) => ({
                text: value,
                value: key
              }))" :label="item.text" :key="idx" :value="item.value" :disabled="item.value !== 'all' && (form.age || []).includes('all')"></el-option>
            </el-select></el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$locale('couponList.distribution.gender')" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.genderCheck" @change="updatePersonCount" /></el-col>
            <el-col :span="4"><el-select v-model="form.gender" clearable multiple @change="change_fn('gender')">
              <el-option v-for="(item, idx) in genderList" :label="item.label" :value="item.value" :key="idx"></el-option>
            </el-select></el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$locale('setting.emergency.perfecture')" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.addressCheck" @change="updatePersonCount" /></el-col>
            <el-col :span="4"><el-select v-model="form.prefecture" clearable multiple @change="change_fn('address')">
              <el-option v-for="(item, idx) in perfectureList" :key="idx" :label="item.name" :value="item.id"></el-option>
            </el-select></el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$locale('mail.memberFilter.cinema')" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.favoriteCinemaCheck" @change="updatePersonCount" /></el-col>
            <el-col :span="4"><el-select v-model="form.favoriteCinemaId" clearable multiple @change="change_fn('favoriteCinema')">
              <el-option v-for="(item, idx) in cinemaList" :key="idx" :label="item.name" :value="item.id"></el-option>
            </el-select></el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="好きなジャンル" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.favoriteGenreCheck" @change="updatePersonCount" /></el-col>
            <el-col :span="4"><el-select v-model="form.favoriteGenres" clearable multiple @change="change_fn('favoriteGenre')">
              <el-option v-for="(item, idx) in favoriteGenres" :key="idx" :label="item.name" :value="item.id"></el-option>
            </el-select></el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$locale('report.memberShip.memberType')" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.membershipCheck" @change="updatePersonCount" /></el-col>
            <el-col :span="4"><el-select v-model="form.membershipId" clearable multiple @change="getMemberRankList">
              <el-option
                v-for="(item, idx) in membershipList"
                :key="idx" :label="item.name"
                :value="item.id"
                :disabled="item.id !== 'all' && (form.membershipId || []).includes('all')"></el-option>
            </el-select></el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$locale('mail.memberFilter.rank')" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.membershipRankCheck" @change="updatePersonCount" /></el-col>
            <el-col :span="6"><el-select v-model="form.membershipRankId" clearable multiple @change="val => selectMember_fn(val, 'membershipRankId')">
              <el-option
                v-for="(item, idx) in memberRankList"
                :key="idx" :label="item.name"
                :value="item.uuid"
                :disabled="item.uuid !== 'all' && (form.membershipRankId || []).includes('all')"></el-option>
            </el-select></el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$locale('mail.memberFilter.seenMovie')" class="condtionFormItem" style="width: 100%;">
          <el-row :gutter="20">
            <el-col :span="1"><el-checkbox v-model="form.movieCheck" @change="updatePersonCount" /></el-col>
            <el-col :span="12"><RemoteSelectV2
                ref="selectV2"
                type="filmForSearch"
                v-model="form.movieId"
                :formValue.sync="form.movieId"
                :list="filmList"
                @setList="arr => filmList = arr"
                :isMultiple="true"
                :placeholder="$locale('form.plsEnterTitleOfWorks')"
                :fields="['id', 'name', 'cinemaId']"
                :clearable="true"
                :cinemaList="cinemaList"
                :isAppendCinemaName="true"
              /></el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <el-row type="flex" align="middle" :gutter="20">
        <el-col class="ta-r" :span="21" style="font-size: 16px;font-weight: 400px;">絞り込んだ人数 : {{personNum}}人</el-col>
        <el-col :span="3"><el-button class="egl-btn-yellow" @click="save_fn" style="width: 100%;">{{ $route.params.id ? "確定" : "作成する"}}</el-button></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import openDateCom from "../MailMagazine/sendFormCom/openDateCom";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";

import { ageGroup } from "@/assets/js/sendCoupon";
import { getMemberGender } from "@/assets/js/membership";
import { favoriteGenres } from "@/pages/MemberShip/MemberFilter/script/index";
import { getRankListForMemberShipIds } from "@/utils/common";
import countDownAlert from "@/utils/countDownAlert";

import { getPrefectureListService, getCinemaListMap, getSimpleMovieList } from "@/helpers/service/api/common";
import { getMemberShipListService } from "@/helpers/service/api/membership";
import { getMailingListService, getMemberCountService, createMailingService, updateMailingService, getMailingDetailService } from "@/helpers/service/api/memberFilter";

export default {
  data() {
    return {
      ageGroup,
      genderList: getMemberGender(),
      mailingId: "",
      form: {
        name: "",
        describe: "",
        // regDateObj: {
        //   startOpenDateType: 'DATE',
        //   startDate: Date.now().valueOf(),
        //   endOpenDateType: 'DATE',
        //   endDate: Date.now().valueOf(),
        // },
        // timeType: "",
        startTime: Date.now().valueOf(),
        endTime: Date.now().valueOf(),
        age: [],
        gender: [],
        prefecture: [],
        cinemas: [],
        genres: [],
        membershipId: [],
        membershipRankId: [],
        movieId: [],
        ageCheck: false,
        favoriteCinemaCheck: false,
        favoriteGenreCheck: false,
        genderCheck: false,
        membershipCheck: false,
        membershipRankCheck: false,
        movieCheck: false,
        timeCheck: false,
        addressCheck: false,
        timeType: "register",
      },
      perfectureList: [],
      cinemaList: [],
      favoriteGenres,
      membershipList: [],
      filmList: [],
      mailingList: [],
      formRules: {
        name: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.news.form.title.required"),
            trigger: ["blur"]
          }
        ],
      },
      personNum: 0,
      actionType: this.$route.path.indexOf("create") > -1 ? "create" : "edit",
    }
  },
  computed: {
    memberRankList: {
      get() {
				return getRankListForMemberShipIds(this.form.membershipId, this.membershipList).length === 0 ? [] : [
					{
						name: "全て",
						uuid: "all"
					},
					...getRankListForMemberShipIds(this.form.membershipId, this.membershipList)
				]
			},
			set(val) {
				return val
			}
    }
  },
  created() {
    getMailingListService({ brandId: window.localStorage.getItem("brandId")}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        this.mailingList = res.data.data;
      }
    });
    getPrefectureListService().then((res) => {
      if (res.data && res.data.length > 0) {
        this.perfectureList = res.data.map((item) => ({
          id: item.name,
          name: item.name
        }));
      }
    });
    getCinemaListMap({ brandId: window.localStorage.getItem("brandId"), status: "active", field: ["id", "name"], page: 0, pageSize: 99999}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        this.cinemaList = res.data.data;
      }
    })
    getMemberShipListService({ brandId: window.localStorage.getItem("brandId"), page: 0, pageSize: 99999}).then((res) => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        this.membershipList = [
          {
            name: "全て",
            id: "all"
          },
          ...res.data.data
        ];
        // this.getMemberRankList(this.form.membershipId, this.membershipList);
      }
    })
    getSimpleMovieList({
      brandId: window.localStorage.getItem("brandId"),
      page: 0,
      pageSize: 20,
      hiddenCms: false,
      status: "active",
      approve: true,
      field: ["id", "name", "cinemaId"]
    }).then(res => {
      if (res.data && res.data.data && res.data.data.length > 0) {
        this.filmList = res.data.data;
      }
    });
  },
  mounted() {
    const mailingId = this.$route.params.id
    if (mailingId) {
      getMailingDetailService({ id: mailingId }).then((res) => {
        if (res.data) {
          this.form = this.applyMailingForm(res.data);
          this.updatePersonCount();
          if (!this.form.membershipId.includes("all")) {
            const rankSource = this.normalizeList(res.data.membershipId);
            this.memberRankList = getRankListForMemberShipIds(rankSource, this.membershipList).length === 0 ? [] : [
              {
                name: "全て",
                uuid: "all"
              },
              ...getRankListForMemberShipIds(rankSource, this.membershipList),
            ]
          } else {
            this.memberRankList = [
              {
                name: "全て",
                uuid: "all"
              },
              ...getRankListForMemberShipIds(this.membershipList.map((item) => item.id), this.membershipList),
            ]
          }
          if (res.data.movieId && res.data.movieId.length > 0) {
            getSimpleMovieList({
              brandId: window.localStorage.getItem("brandId"),
              page: 0,
              pageSize: 99999,
              hiddenCms: false,
              status: "active",
              approve: true,
              ids: res.data.movieId,
              field: ["id", "name", "cinemaId"]
            }).then(res => {
              if (res.data && res.data.data && res.data.data.length > 0) {
                this.filmList = this.$_.uniqBy([...res.data.data, ...this.filmList], "id");
              }
            });
          }
        }
      })
    } else {
      this.updatePersonCount();
    }
  },
  methods: {
    // API may return null for unchecked filter fields after save-without-value change
    normalizeAllList(val) {
      if (!Array.isArray(val) || val.length === 0) {
        return ["all"];
      }
      return val;
    },
    normalizeList(val) {
      return Array.isArray(val) ? val : [];
    },
    applyMailingForm(data) {
      return {
        ...data,
        age: this.normalizeAllList(data.age),
        gender: this.normalizeList(data.gender),
        prefecture: this.normalizeList(data.prefecture),
        favoriteCinemaId: this.normalizeList(data.favoriteCinemaId),
        favoriteGenres: this.normalizeList(data.favoriteGenres),
        membershipId: this.normalizeAllList(data.membershipId),
        membershipRankId: this.normalizeAllList(data.membershipRankId),
        movieId: this.normalizeList(data.movieId),
        startTime: data.startTime || Date.now().valueOf(),
        endTime: data.endTime || Date.now().valueOf(),
        timeType: data.timeType || "register",
        timeCheck: !!data.timeCheck,
        ageCheck: !!data.ageCheck,
        genderCheck: !!data.genderCheck,
        addressCheck: !!data.addressCheck,
        favoriteCinemaCheck: !!data.favoriteCinemaCheck,
        favoriteGenreCheck: !!data.favoriteGenreCheck,
        membershipCheck: !!data.membershipCheck,
        membershipRankCheck: !!data.membershipRankCheck,
        movieCheck: !!data.movieCheck,
      };
    },
    selectAge_fn(value) {
      if ((value || []).includes("all")) {
        this.form.age = ['all'];
      }
      if (this.form.ageCheck) {
        this.updatePersonCount();
      }
    },
    selectMember_fn(val, key) {
      if ((val || []).includes("all")) {
        this.form[key] = ["all"];
      }
      if (key === 'membershipId' && this.form.membershipCheck) {
        this.updatePersonCount();
      }
      if (key === 'membershipRankId' && this.form.membershipRankCheck) {
        this.updatePersonCount();
      }
      // if (this.form.membershipRankCheck) {
      //   this.updatePersonCount();
      // }
    },
    getMemberRankList(val) {
      const selected = val || [];
      this.selectMember_fn(selected, "membershipId")
      this.form.membershipRankId = [];
      if (!selected.includes("all")) {
        this.memberRankList = getRankListForMemberShipIds(selected, this.membershipList).length === 0 ? [] : [
          {
            name: "全て",
            uuid: "all"
          },
          ...getRankListForMemberShipIds(selected, this.membershipList),
        ]
      } else {
        this.memberRankList = [
          {
            name: "全て",
            uuid: "all"
          },
          ...getRankListForMemberShipIds(this.membershipList.map((item) => item.id), this.membershipList),
        ]
      }
      
    },
    copy_fn() {
      const targetObj = this.mailingList.find((item) => item.id === this.mailingId);
      if (!targetObj) return;
      this.form = this.applyMailingForm(targetObj);
      if (!this.form.membershipId.includes("all")) {
        const rankSource = this.normalizeList(targetObj.membershipId);
        this.memberRankList = getRankListForMemberShipIds(rankSource, this.membershipList).length === 0 ? [] : [
          {
            name: "全て",
            uuid: "all"
          },
          ...getRankListForMemberShipIds(rankSource, this.membershipList),
        ]
      } else {
        this.memberRankList = [
          {
            name: "全て",
            uuid: "all"
          },
          ...getRankListForMemberShipIds(this.membershipList.map((item) => item.id), this.membershipList),
        ]
      }
      this.updatePersonCount();
    },
    /**
     * Build API payload for create / edit / member-count.
     * Unchecked conditions: do not send their input values (even if UI still has them).
     */
    buildMailingPayload() {
      const {
        id,
        name,
        describe,
        timeCheck,
        ageCheck,
        genderCheck,
        addressCheck,
        favoriteCinemaCheck,
        favoriteGenreCheck,
        membershipCheck,
        membershipRankCheck,
        movieCheck,
        timeType,
        startTime,
        endTime,
        age,
        gender,
        prefecture,
        favoriteCinemaId,
        favoriteGenres,
        membershipId,
        membershipRankId,
        movieId,
      } = this.form;

      const payload = {
        name,
        describe,
        brandId: window.localStorage.getItem("brandId"),
        timeType, // always required, not gated by checkbox
        timeCheck: !!timeCheck,
        ageCheck: !!ageCheck,
        genderCheck: !!genderCheck,
        addressCheck: !!addressCheck,
        favoriteCinemaCheck: !!favoriteCinemaCheck,
        favoriteGenreCheck: !!favoriteGenreCheck,
        membershipCheck: !!membershipCheck,
        membershipRankCheck: !!membershipRankCheck,
        movieCheck: !!movieCheck,
      };

      if (id) {
        payload.id = id;
      }

      // Only attach filter values when the matching checkbox is checked
      if (timeCheck) {
        payload.startTime = startTime;
        payload.endTime = endTime;
      }
      if (ageCheck) {
        payload.age = (age || []).includes("all") ? [] : age;
      }
      if (genderCheck) {
        payload.gender = gender;
      }
      if (addressCheck) {
        payload.prefecture = prefecture;
      }
      if (favoriteCinemaCheck) {
        payload.favoriteCinemaId = favoriteCinemaId;
      }
      if (favoriteGenreCheck) {
        payload.favoriteGenres = favoriteGenres;
      }
      if (membershipCheck) {
        payload.membershipId = (membershipId || []).includes("all") ? [] : membershipId;
      }
      if (membershipRankCheck) {
        payload.membershipRankId = (membershipRankId || []).includes("all") ? [] : membershipRankId;
      }
      if (movieCheck) {
        payload.movieId = movieId;
      }

      return payload;
    },
    updatePersonCount(val) {
      // if (val === false) return;
      getMemberCountService(this.buildMailingPayload()).then((res) => {
        this.personNum = res.data;
      })
    },
    save_fn() {
      this.$refs.detailForm.validate((isValid) => {
        if (isValid) {
          const obj = this.$_.cloneDeep(this.buildMailingPayload());
          if (this.actionType === "create") {
            createMailingService(obj).then((res) => {
              if (res.success) {
                countDownAlert({ content: this.$locale("global.createSuccessfully"), callback: () => {
                  this.$router.push('/member-filter');
                }});
              }
            })
          } else {
            updateMailingService(obj).then((res) => {
              if (res.success) {
                countDownAlert({ content: this.$locale("global.updateSuccessfully"), callback: () => {
                  this.$router.push('/member-filter');
                }});
              }
            })
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);
          return false;
        }
      })
    },
    change_fn(val) {
      if (this.form[val + 'Check']) {
        this.updatePersonCount();
      }
    }
  },
  components: {
    openDateCom,
    RemoteSelectV2,
  },
}
</script>
<style lang="less" scoped>
.memberFilterForm ::v-deep .el-form-item__content {
  width: calc(100% - 80px);
}
.condtionFormItem {
  ::v-deep .el-form-item__content {
    width: 100%;
  }
  ::v-deep .el-checkbox__label {
    display: none;
  }
}
</style>